import request from '@/utils/request'

// epmsb100
export function epmsb100(param) {
  let data = param
  return request({
    url: `/requestPoMaterial/epmsb100/epmsb100`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epmsb101SendYn
export function epmsb101SendYn(param) {
  let data = param
  return request({
    url: `/requestPoMaterial/epmsb100/epmsb101SendYn`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epmsb101
export function epmsb101(param) {
  let data = param
  return request({
    url: `/requestPoMaterial/epmsb100/epmsb101`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epms7000ShipPnt
export function epms7000ShipPnt(param) {
  let data = param
  return request({
    url: `/requestPoMaterial/epmsb100/epms7000ShipPnt`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epmsb102
export function epmsb102(param) {
  let data = param
  return request({
    url: `/requestPoMaterial/epmsb100/epmsb102`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epmsb100Save
export function epmsb100Save(param) {
  let data = param
  return request({
    url: `/requestPoMaterial/epmsb100/epmsb100Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}